import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authSlice from "../slice/authSlice";
import commonSlice from "../slice/commonSlice";
import colorSlice from "../slice/colorSlice";
import collectionSlice from "../slice/collectionSlice";
import couponSlice from "../slice/couponSlice";
import bannerSlice from "../slice/bannerSlice";
import roleSlice from "../slice/roleSlice";
import userSlice from "../slice/userSlice";
import supplierSlice from "../slice/supplierSlice";
import variantSlice from "../slice/variantSlice";
import productSlice from "../slice/productSlice";
import prebookOrderSlice from "../slice/prebookOrderSlice";
import purchaseOrderSlice from "../slice/purchaseOrderSlice";
import returnSlice from "../slice/returnSlice";
import invoiceSlice from "../slice/invoiceSlice";
import knitterOrderSlice from "../slice/knitterOrderSlice";
import logsSlice from "../slice/logsSlice";
import millPurchaseSlice from "../slice/millPurchaseSlice";
import millOrderSlice from "../slice/millOrderSlice";
import dashboardSlice from "../slice/dashboardSlice";
import notificationSlice from "../slice/notificationSlice";
import variantLowStockSlice from "../slice/variantLowStockSlice";
import partyRateSlice from "../slice/partyRateSlice";
import partyNumberSlice from "../slice/partyNumberSlice";
import settingsSlice from "../slice/settingsSlice";
import leadSlice from "../slice/leadSlice";
import supplierNotificationSlice from "../slice/supplierNotificationSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  common: commonSlice,
  color: colorSlice,
  collection: collectionSlice,
  coupon: couponSlice,
  banner: bannerSlice,
  role: roleSlice,
  user: userSlice,
  supplier: supplierSlice,
  product: productSlice,
  variant: variantSlice,
  partyRate: partyRateSlice,
  partyNumber: partyNumberSlice,
  prebookOrder: prebookOrderSlice,
  purchaseOrder: purchaseOrderSlice,
  returnOrder: returnSlice,
  invoice: invoiceSlice,
  knitterOrder: knitterOrderSlice,
  logs: logsSlice,
  millPurchase: millPurchaseSlice,
  millOrder: millOrderSlice,
  dashboard: dashboardSlice,
  notifications: notificationSlice,
  variantLowStock: variantLowStockSlice,
  settings: settingsSlice,
  lead: leadSlice,
  supplierNotification: supplierNotificationSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== "production",
});

export const persister = persistStore(store);
